import { useEffect } from 'react'
import useUser from 'sdk/hooks/user/useProfile'

export const useEvents = () => {
  const { data: profile } = useUser()
  useEffect(() => {
    const onstorage = (event) => {
      // if (window.name === 'auth') {
      //   window.close()
      // }
      if (event.key === 'isAuth' || event.key === 'isProviderUpdated') {
        window.location.reload()
      }
    }
    window.addEventListener('storage', onstorage)

    return () => window.removeEventListener('storage', onstorage);
  }, [])

  useEffect(() => {
    if (profile && !profile?.birthday) {
      // Если нет дня рождения, т.е человек не до конца прошел регистрицию, выходим из системы
      // logoutMutation.mutate()
    }
  }, [profile])
}
